module.exports = __webpack_public_path__ + "static/media/standardHashrate-dark.a8e44fe0.png";